<template>
  <!-- 🎯 公告弹框 -->
  <div v-if="visible" class="notice-overlay" @click="handleOverlayClick">
    <div class="notice-dialog" @click.stop>
      <!-- 关闭按钮 -->
      <div class="notice-close" @click="closeDialog">
        <i class="el-icon-close"></i>
      </div>
      
      <!-- 公告标题 -->
      <div class="notice-title">{{ title }}</div>
      
      <!-- 公告内容 -->
      <div class="notice-content">
        <div class="notice-text" v-html="formattedContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 格式化内容，将换行符转换为<br>
    formattedContent() {
      if (!this.content) return '';
      return this.content.replace(/\n/g, '<br>');
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    
    handleOverlayClick() {
      // 点击遮罩层关闭弹框
      this.closeDialog();
    }
  }
}
</script>

<style scoped>
.notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.notice-dialog {
  background: #ffffff;
  border-radius: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.15);
  max-width: 5rem;
  width: 90%;
  max-height: 70vh;
  position: relative;
  overflow: hidden;
}

.notice-close {
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
  width: 0.24rem;
  height: 0.24rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s;
}

.notice-close:hover {
  color: #000000;
}

.notice-close i {
  font-size: 0.3rem;
  color: #000000;
}

.notice-title {
  padding: 0.2rem 0.2rem 0.1rem 0.2rem;
  font-size: 0.35rem;
  font-weight: 600;
  color: #000000;
  text-align: left;
  /* border-bottom: 1px solid #f0f0f0; */
  margin-bottom: 0;
  padding-right: 0.5rem; /* 为关闭按钮留出空间 */
}

.notice-content {
  padding: 0.2rem;
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: .2rem;
}

.notice-text {
  font-size: 0.14rem;
  line-height: 1.6;
  color: #000000;
  word-wrap: break-word;
  white-space: pre-wrap;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .notice-dialog {
    width: 90%;
    max-width: none;
  }
  
  .notice-title {
    font-size: 0.35rem;
    padding: 0.3rem 0.5rem 0.3rem 0.3rem;
    padding-right: 0.45rem;
  }

  .notice-content {
    padding: 0rem 0.3rem 0.3rem 0.3rem;
  }

  .notice-text {
    font-size: 0.18rem;
  }

  .notice-close {
    top: 0.1rem;
    right: 0.1rem;
    width: 0.3rem;
    height: 0.3rem;
  }

  .notice-close i {
    font-size: 0.35rem;
  }
}

/* 滚动条样式 */
.notice-content::-webkit-scrollbar {
  width: 0.04rem;
}

.notice-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0.02rem;
}

.notice-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 0.02rem;
}

.notice-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
